import React from 'react';
import { ArrowRight, FileText } from 'lucide-react';

const FeeForwardReport = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Fee Forward Report</h1>
        <p className="text-sm text-gray-500 mt-1">Track forwarded fees across semesters</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-white p-6 rounded-lg shadow">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500">Total Forwards</p>
              <p className="text-3xl font-bold text-gray-900 mt-1">0</p>
            </div>
            <ArrowRight className="h-12 w-12 text-blue-500" />
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500">Amount Forwarded</p>
              <p className="text-3xl font-bold text-orange-600 mt-1">₹0</p>
            </div>
            <ArrowRight className="h-12 w-12 text-orange-500" />
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500">Students Affected</p>
              <p className="text-3xl font-bold text-gray-900 mt-1">0</p>
            </div>
            <FileText className="h-12 w-12 text-purple-500" />
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow p-8 text-center">
        <ArrowRight className="h-16 w-16 text-gray-400 mx-auto mb-4" />
        <p className="text-gray-500">No fee forward records available</p>
      </div>
    </div>
  );
};

export default FeeForwardReport;